import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleAuthService {



  url = environment.serverAPI9 + "/api";



  constructor(private http: HttpClient) {

  }

  private clientId = '181511745860-6scddhvm2svhvs6oe4ntivtcv8s8s0r0.apps.googleusercontent.com';
  private redirectUri = this.url + '/ig/callback/google';
  private redirectUriGoogleAds = this.url + '/ig/google/ads/oauth/callback';
  private scope = [
    'https://www.googleapis.com/auth/userinfo.email',
    'https://www.googleapis.com/auth/contacts',
    'https://mail.google.com/',
    'https://www.googleapis.com/auth/calendar'
  ].join(' ');

  private scopeGoogleAds = [
    'https://www.googleapis.com/auth/adwords',
    'https://www.googleapis.com/auth/datamanager'
  ].join(' ');

  loginWithGoogle() {
    const state = this.generateRandomString();
    const url =
      `https://accounts.google.com/o/oauth2/v2/auth?client_id=${this.clientId}` +
      `&redirect_uri=${encodeURIComponent(this.redirectUri)}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(this.scope)}` +
      `&access_type=offline&prompt=consent&state=${state}`;
    window.location.href = url;
  }

  private generateRandomString(length: number = 16): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  private getGoogleAdsApiUrl(): string {
    return this.url.replace(/\/google$/, '');
  }

  loginWithGoogleAds(clientId: string) {

    const state1 = this.generateRandomString();

    const url =
      `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}` +
      `&redirect_uri=${encodeURIComponent(this.redirectUriGoogleAds)}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(this.scopeGoogleAds)}` +
      `&access_type=offline&prompt=consent&state=${state1}`;

    window.location.href = url;
  }


  saveUserId(googleId: number, multiplelogin: string = '0'): Observable<Object> {
    return this.http.get(`${this.url}/callback/google/${googleId}?multiplelogin=${multiplelogin}`);
  }

  getGoogleAdsToken(): Observable<Object> {
    return this.http.get(`${this.url.replace('/google', '')}/google-ads/connection`);
  }

  disconnectGoogleAds(googleAdsTokenId: any): Observable<Object> {
    return this.http.get(`${this.url.replace('/google', '')}/google-ads/disconnect/${googleAdsTokenId}`);
  }

  saveUserIdGoogleAds(googleAdsTokenId: number, multiplelogin: string = '0'): Observable<Object> {
    return this.http.get(`${this.url}/callback/google-ads/${googleAdsTokenId}?multiplelogin=${multiplelogin}`);
  }

  saveUserIdCalendly(googleId: number, multiplelogin?: string): Observable<Object> {
    return this.http.get(`${this.url}/callback/calendly/${googleId}`);
  }

  updateGoogleCalender(googleCalender: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/create-event/google/calender/`, googleCalender);
  }

  saveUserIdApollo(tokenId: number, multiplelogin?: string): Observable<Object> {
    return this.http.get(`${this.url}/callback/apollo/${tokenId}`);
  }
  saveWebhookData(webhook: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/apollo/webhook`, webhook);
  }

  saveUserIdZoom(tokenId: number, multiplelogin?: string): Observable<Object> {
    return this.http.get(`${this.url}/callback/zoom/${tokenId}`);
  }

}